import { Component } from '@angular/core';

@Component({
  selector: 'app-jee-mains-link',
  templateUrl: './jee-mains-link.component.html',
  styleUrls: ['./jee-mains-link.component.scss']
})
export class JeeMainsLinkComponent {

}
